import moment from 'moment';

const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

function convertDateToISO8601(dateObj) {
  return moment.utc(dateObj).format('Y-MM-DDTHH:mm:ss');
}

export { weekDays, convertDateToISO8601 };
